// @ts-nocheck
import './App.css';
import Navigation from './navigation';
import React, { useState, useEffect } from 'react';

function App() {
  const [time, setTime] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => setTime(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);

  const formattedTime = time.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false });

  return (
    <div className="min-h-screen bg-slate-200 lg:flex lg:items-center lg:justify-center lg:py-8 font-sans">
      {/* The translateZ only applies from lg up, where it keeps the header and bottom
          nav inside the phone frame. On a real phone it must not be there: a transform
          makes position:fixed resolve against this element instead of the viewport, and
          the header and bottom nav scroll away with the page. Same for overflow-hidden,
          which would otherwise become the scroll context every sticky bar sticks to. */}
      <div className="w-full min-h-screen lg:min-h-0 lg:h-[850px] lg:max-h-[90vh] lg:w-[390px] lg:bg-white lg:rounded-[3rem] lg:shadow-2xl lg:border-[12px] lg:border-gray-900 lg:overflow-hidden relative App flex flex-col lg:[transform:translateZ(0)]">
        {/* Fake iOS Notch for desktop purely for aesthetics */}
        <div className="hidden lg:block absolute top-0 left-1/2 -translate-x-1/2 h-6 bg-gray-900 rounded-b-2xl w-[120px] z-50"></div>
        
        {/* Fake iOS Status Bar */}
        <div className="hidden lg:flex absolute top-0 inset-x-0 h-10 items-center justify-between px-6 z-[60] text-[13px] font-semibold text-black tracking-tight pt-1">
          <span>{formattedTime}</span>
          <div className="flex items-center gap-1.5">
            {/* Signal */}
            <svg width="17" height="11" viewBox="0 0 17 11" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect y="7" width="3" height="4" rx="1" fill="currentColor"/>
              <rect x="4" y="5" width="3" height="6" rx="1" fill="currentColor"/>
              <rect x="8" y="2" width="3" height="9" rx="1" fill="currentColor"/>
              <rect x="12" width="3" height="11" rx="1" fill="currentColor"/>
            </svg>
            {/* Wifi */}
            <svg width="15" height="11" viewBox="0 0 15 11" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M7.5 11C8.32843 11 9 10.3284 9 9.5C9 8.67157 8.32843 8 7.5 8C6.67157 8 6 8.67157 6 9.5C6 10.3284 6.67157 11 7.5 11Z" fill="currentColor"/>
              <path d="M11 6.5C9.067 4.567 5.933 4.567 4 6.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
              <path d="M14 3.5C10.4101 -0.089859 4.58986 -0.089859 1 3.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
            </svg>
            {/* Battery */}
            <svg width="25" height="12" viewBox="0 0 25 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="0.5" y="0.5" width="21" height="11" rx="3.5" stroke="currentColor"/>
              <rect x="2" y="2" width="18" height="8" rx="2" fill="currentColor"/>
              <path d="M23 4V8" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
            </svg>
          </div>
        </div>

        {/* App Content */}
        {/* Scrolls internally only inside the desktop phone frame. On a phone the window
            scrolls, and an overflow container here would become the sticky scroll context
            and stop every sticky bar in the app from sticking. */}
        <div id="app-scroll" className="flex-1 h-full lg:overflow-y-auto bg-slate-50 relative hide-scrollbar lg:pt-10 lg:pb-6">
          <Navigation />
        </div>

        {/* Fake iOS Home Indicator */}
        <div className="hidden lg:flex absolute bottom-0 inset-x-0 h-6 items-end justify-center pb-2 z-[60] bg-gradient-to-t from-white to-transparent pointer-events-none">
          <div className="w-[130px] h-1 bg-black rounded-full"></div>
        </div>
      </div>
    </div>
  );
}

export default App;
